export const DASHBOARD_SOURCE_GET_SOURCE = 'DASHBOARD_SOURCE_GET_SOURCE';
export const DASHBOARD_SOURCE_GET_SOURCE_SUCCESS = 'DASHBOARD_SOURCE_GET_SOURCE_SUCCESS';
export const DASHBOARD_SOURCE_GET_SOURCE_FAIL = 'DASHBOARD_SOURCE_GET_SOURCE_FAIL';

export const DASHBOARD_SOURCE_SET_FILTER = 'DASHBOARD_SOURCE_SET_FILTER';

export const DASHBOARD_SOURCE_REMOVE_EVENT = 'DASHBOARD_SOURCE_REMOVE_EVENT';
